module.exports = __webpack_public_path__ + "img/11.a9803f0f.jpg";